import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing8 } from 'approot/shared/styles/spacing.style';

export const ResponsePrintAnswerContainer = styled.div`
  & > div {
    margin-bottom: ${rem(spacing8)};
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
